export default class MenuModel {
    public icon: string
    public title: string
    public url: string
}